// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TableRow_wrapper__2C4MY","itemWrapper":"TableRow_itemWrapper__10jFG","item":"TableRow_item__3e2pK"};